import { ISelectedPoint } from '@features/checkout/typescript';
import { getRegion } from '@utils/misc';
import browserStorage from '@utils/browserStorage';
export const setSelectedDeliveryAdditionalData = (selectedDeliveryAdditionalData: Record<string, ISelectedPoint>) => {
  if (typeof window === 'undefined') return;
  const region = getRegion();
  if (browserStorage) {
    browserStorage.setItem(`pointAdditionalData_${region}`, JSON.stringify(selectedDeliveryAdditionalData));
  }
};
export const getSelectedDeliveryAdditionalData = (): Record<string, ISelectedPoint> | null => {
  if (typeof window === 'undefined') return null;
  const region = getRegion();
  const locaStorageData = browserStorage ? browserStorage.getItem(`pointAdditionalData_${region}`) : null;
  if (!locaStorageData || locaStorageData.length === 0) return null;
  const pointAdditionalData = JSON.parse(locaStorageData);
  return pointAdditionalData;
};
export const clearSelectedDeliveryAdditionalData = () => {
  if (typeof window === 'undefined') return;
  const region = getRegion();
  if (browserStorage) {
    browserStorage.setItem(`pointAdditionalData_${region}`, '');
  }
};